import '../configure';
import { AppBaseStore } from './app-base-store';
import { ShareDataStore } from './share-data-store';
import { SettingStore } from './setting-store';
import { CalendarStore } from './calendar-store';
import { KolStore } from './kol/kol-store';
import { RaceBetPickStore } from './kol/race-page-store';
import { ProfilePageStore } from './kol/leader-page-store';
import { VideoPopupStore } from './video-popup-store';

export class GlobalStore {
    baseStore: AppBaseStore = new AppBaseStore();
    settingStore: SettingStore = new SettingStore(this.baseStore);
    shareDataStore = new ShareDataStore(this.baseStore, this.settingStore);
    calendarStore = new CalendarStore(this.baseStore, this.settingStore);
    kolStore = new KolStore();
    racePageStore = new RaceBetPickStore(this.kolStore);
    profilePageStore = new ProfilePageStore(this.kolStore);
    videoPopupStore = new VideoPopupStore(this.baseStore, this.settingStore);
}
